export default "__VITE_ASSET__DeR3qXpO__"